

import Vue from 'vue';
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { NavLink } from '@/models/types';
import RepsolNavBarListComponent from '@/components/repsol-nav-bar-list/RepsolNavBarListComponent.vue';
import { isMobile } from '@/utils/Breakpoints';
import { AppNavLinks, AppNavLinksBottom } from '@/business/settings'
import store from '@/store';
import { UserIdentityModel } from '@/models/file-entities.model';


@Component({
    name: 'RepsolNavBarComponent',
    components: {
        RepsolNavBarListComponent
    }
})

export default class RepsolNavBarComponent extends Vue {
    @Prop()
    public icons!: boolean;

    @Model()
    private menuExpanded!: boolean;
    private menuExpandedInternal = false;

    private userIdentity : UserIdentityModel;

    @Watch('userIdentity')
    private userIdentityChanged(userIdentity: any) {
        this.loadNavLinks();
    }

    @Watch('menuExpandedInternal')
    private menuExpandedInternalChanged(menuExpandedInternal: any) {
        this.$emit('menuExpanded', menuExpandedInternal);
    }

    @Watch('menuExpanded')
    private menuExpandedChanged(menuExpanded: any) {
        this.menuExpandedInternal = menuExpanded;
    }
    public navLinks: NavLink[] = [];
    public navLinksBottom: NavLink[] = AppNavLinksBottom;

    constructor() {
        super();
        this.menuExpandedInternal = !isMobile();
    }

    mounted(){
        this.userIdentity = (store.state as any).userIdentity.userIdentity as UserIdentityModel;
        this.loadNavLinks();
    }

    loadNavLinks(): void{
        this.navLinks = [];
        if(this.userIdentity && this.userIdentity.modulos){
            const modulesAccess :string[] = [];

            for (const property in this.userIdentity.modulos) {
                modulesAccess.push(property);
            }

            console.log("loadNavLinks", modulesAccess);
            structuredClone(AppNavLinks).forEach(nav => {
                if(nav.children){
                     console.log("children", nav.children.map(c => c));

                    nav.children = nav.children.filter(c => !c.moduleAccess || modulesAccess.indexOf(c.moduleAccess) !== -1);
                    console.log("children filter", nav.children.map(c => c));

                    if(nav.children.length > 0) {
                        this.navLinks.push(nav);
                    }
                }
            });
        }

    }
}

Vue.component('repsol-nav-bar', RepsolNavBarComponent);
